import TablePage from "./pages/table";
import ViewPage from "./pages/view";
import { useEffect } from "react";
import i18n from "./i18n";

function App() {
  // @ts-ignore
  const renderPageName = window._WM_PAGE_NAME as "table" | "view";

  useEffect(() => {
    // @ts-ignore
    if (window.wmLang) {
      // @ts-ignore
      i18n.changeLanguage(window.wmLang)
    }
  }, [])

  if (renderPageName === "table") {
    return <TablePage />
  }

  if (renderPageName === "view") {
    return <ViewPage />
  }

  return <></>
}

export default App;
